import { useState, useEffect } from 'react';

export type OSType = 'windows' | 'macos' | 'linux' | 'unknown';

interface OSDetectionResult {
  os: OSType;
  isLoading: boolean;
}

/**
 * Hook to detect the user's operating system
 * Uses navigator.userAgent and navigator.platform for detection
 */
export function useOSDetection(): OSDetectionResult {
  const [os, setOS] = useState<OSType>('unknown');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const detectOS = (): OSType => {
      const userAgent = navigator.userAgent.toLowerCase();
      const platform = navigator.platform.toLowerCase();

      // Check for Windows
      if (platform.includes('win') || userAgent.includes('windows')) {
        return 'windows';
      }

      // Check for macOS
      if (
        platform.includes('mac') ||
        userAgent.includes('macintosh') ||
        userAgent.includes('mac os x')
      ) {
        return 'macos';
      }

      // Check for Linux (but not Android)
      if (
        (platform.includes('linux') || userAgent.includes('linux')) &&
        !userAgent.includes('android')
      ) {
        return 'linux';
      }

      return 'unknown';
    };

    setOS(detectOS());
    setIsLoading(false);
  }, []);

  return { os, isLoading };
}
